import React, { useRef, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobe,
  faBullhorn,
  faRobot,
} from '@fortawesome/free-solid-svg-icons';
import Slider from 'react-slick';
import { PrimaryButton } from '../common/Buttons';

import Slide1Img from '../images/slide1.png';
import Slide2Img from '../images/slide2.png';
import Slide3Img from '../images/slide3.png';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.css';

const slides = [
  {
    title: 'Web Experiences',
    highlight: 'that Convert Visitors into Clients',
    description:
      'Your website is your first impression. Let’s make it unforgettable, fast, and persuasive.',
    buttonLabel: 'Build My Site',
    buttonIcon: faGlobe,
    navIcon: faGlobe,
    image: Slide1Img,
    link: 'web-development',
  },
  {
    title: 'Digital Campaigns',
    highlight: 'with Real Impact',
    description:
      'Launch digital campaigns that reach the right people with the right message, every time.',
    buttonLabel: 'Grow Now',
    buttonIcon: faBullhorn,
    navIcon: faBullhorn,
    image: Slide2Img,
    link: '/contact',
  },
  {
    title: 'AI Automation',
    highlight: 'Tailored for Your Business',
    description:
      'Save time, increase precision, and scale effortlessly with our AI-driven workflows.',
    buttonLabel: 'Boost with AI',
    buttonIcon: faRobot,
    navIcon: faRobot,
    image: Slide3Img,
    link: '/contact',
  },
];

function SliderSection() {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3600,
    pauseOnHover: true,
    arrows: false,
    beforeChange: (_, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 900,
        settings: {
          autoplaySpeed: 4000,
        },
      },
    ],
  };

  return (
    <section id="sliders" className="slider-section">
      <Container className="py-5">
        <Slider ref={sliderRef} {...settings}>
          {slides.map((slide, idx) => (
            <div key={slide.title}>
              <Row className="align-items-center py-5 flex-column-reverse flex-md-row">
                <Col xs="12" md="7" className="text-center text-md-start mb-4 mb-md-0">
                  <h2 className="slider-title fw-bold mb-3">
                    {slide.title}{' '}
                    <span className="slider-highlight">
                      {slide.highlight}
                    </span>
                  </h2>
                  <p className="slider-description text-secondary mb-4">
                    {slide.description}
                  </p>
                  <PrimaryButton
                    icon={<FontAwesomeIcon icon={slide.buttonIcon} />}
                    href={slide.link}
                    aria-label={`${slide.buttonLabel} - Learn more about ${slide.title}`}
                  >
                    {slide.buttonLabel}
                  </PrimaryButton>
                </Col>
                <Col xs="12" md="5" className="text-center">
                  <img
                    src={slide.image}
                    alt={`${slide.title}: ${slide.description}`}
                    className="slider-image img-fluid"
                    loading={idx === 0 ? 'eager' : 'lazy'}
                  />
                </Col>
              </Row>
            </div>
          ))}
        </Slider>

        <Row className="justify-content-center mt-5">
          {slides.map(({ navIcon, title }, index) => (
            <Col xs="4" sm="2" md="1" key={title} className="text-center">
              <div
                className={`slider-nav-icon${activeSlide === index ? ' active' : ''}`}
                onClick={() => sliderRef.current?.slickGoTo(index)}
                aria-label={`Go to slide ${index + 1}: ${title}`}
                role="button"
                tabIndex={0}
              >
                <FontAwesomeIcon icon={navIcon} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default SliderSection;
